import Vue from 'vue'
import { hasIamPermission } from '@/utils/iamEvaluator'

// Define the global custom directive v-iam-disabled
Vue.directive('iam-disabled', {
  bind(el, binding, vnode) {
    const store = vnode.context.$store

    const checkPermission = () => {
      // Check if user is WFM_ADMIN via local storage user session
      let isWfmAdmin = false
      try {
        const userObj = JSON.parse(localStorage.getItem('user'))
        if (userObj) {
          const roles = userObj.role || userObj.cwRole || []
          if (roles.includes('WFM_ADMIN')) {
            isWfmAdmin = true
          }
        }
      } catch (e) {
        console.error('Error parsing user roles in directive:', e)
      }

      const statements = store.state.wfmStatements || []
      const actionKey = binding.value

      const hasPermission = isWfmAdmin || hasIamPermission(statements, actionKey)

      if (!hasPermission) {
        // Apply HTML attribute
        el.setAttribute('disabled', 'disabled')

        // Add styling classes for locked elements
        el.classList.add('cursor-default')
        if (el.classList.contains('v-btn')) {
          el.classList.add('v-btn--disabled')
        }

        // Apply to child interactive inputs (e.g. nested inputs inside vuetify wrappers like v-select, v-autocomplete)
        const inputs = el.querySelectorAll(
          'input, select, textarea, button, .v-input__slot, .v-select__slot'
        )
        inputs.forEach((input) => {
          input.setAttribute('disabled', 'disabled')
          input.classList.add('cursor-default')
          if (
            input.classList.contains('v-input__slot') ||
            input.classList.contains('v-select__slot')
          ) {
            input.style.setProperty('pointer-events', 'none', 'important')
          }
        })

        // Custom color rules for icons if applicable (e.g. settings buttons, but not text)
        if (el.classList.contains('v-icon')) {
          el.style.setProperty('color', '#E0E0E0', 'important') // light grey for pure action icons
        }

        // Intercept and stop clicks at capturing phase
        el.addEventListener('click', captureAndStopClick, true)
      } else {
        el.removeAttribute('disabled')
        el.classList.remove('cursor-default')
        if (el.classList.contains('v-btn')) {
          el.classList.remove('v-btn--disabled')
        }
        const inputs = el.querySelectorAll(
          'input, select, textarea, button, .v-input__slot, .v-select__slot'
        )
        inputs.forEach((input) => {
          input.removeAttribute('disabled')
          input.classList.remove('cursor-default')
          if (
            input.classList.contains('v-input__slot') ||
            input.classList.contains('v-select__slot')
          ) {
            input.style.removeProperty('pointer-events')
          }
        })
        el.removeEventListener('click', captureAndStopClick, true)
      }
    }

    function captureAndStopClick(e) {
      e.preventDefault()
      e.stopPropagation()
      e.stopImmediatePropagation()
      return false
    }

    // Set up a store watcher so that when wfmStatements asynchronously changes, we run checkPermission
    if (store) {
      const unwatch = store.watch(
        (state) => state.wfmStatements,
        () => {
          checkPermission()
        },
        { deep: true }
      )
      el._iamUnwatch = unwatch
    }

    el._iamCheck = checkPermission
    checkPermission()
  },

  update(el, binding) {
    if (el._iamCheck) {
      el._iamCheck()
    }
  },

  unbind(el) {
    if (el._iamUnwatch) {
      el._iamUnwatch()
    }
    el.removeEventListener('click', el._iamCheck, true)
    delete el._iamCheck
    delete el._iamUnwatch
  }
})
